import z from 'zod';

export enum AuditStatusFilter {
    All = 'All',
    Pending = 'Pending',
    Completed = 'Completed',
    Failed = 'Failed',
}

export const AuditStatusSearchFilterSchema = z.object({
    auditStatus: z.nativeEnum(AuditStatusFilter).catch(AuditStatusFilter.All),
});
